<template>
  <div id="app">
    <component :is="layout">
      <component :is="component" />
    </component>
  </div>
</template>

<script>
import router from './core/router'

export default {
  name: 'App',
  components: router.components,
  data() {
    return {
      layout: undefined,
      component: undefined
    }
  },
  created() {
    window.vm = this
    document.title = this.$config.name
    this.init()
    this.$router.onPathChange('router', () => {
      this.init()
    })
  },
  methods: {
    init() {
      const curPage = this.$router.curPage
      this.component = 'c' + curPage
      this.layout = this.$router.pages[curPage].layout
    }
  }
}
</script>

<style lang="scss">
@import './styles/element-reverse.scss';
@import './styles/june-virtual.scss';
@import './styles/variable.scss';

* {
  margin: 0;
  padding: 0;
}

.main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100vw;
  overflow-x: hidden;
}
.card-content .row {
  margin-bottom: 10px;
}
.tip-card {
  padding: 33px;
  margin: 25px 0;
  background-color: #eef2ff;
  box-shadow: 2px 2px 4px -2px #b3b9d1;
  border-radius: 16px;
  &.warnig {
    background-color: #ffeadb;
    box-shadow: 2px 2px 4px -2px #ffe58f;
  }
  &.danger {
    background-color: #ffe4e4;
    box-shadow: 2px 2px 4px -2px #ffa39e;
  }
  .title {
    font-size: 18px;
    color: #000000d1;
    font-weight: bold;
    margin-bottom: 10px;
    user-select: none;
  }
  .info {
    font-size: 16px;
    color: #000000b7;
    white-space: pre;
    line-height: 22px;
  }
  .dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #00000099;
    display: inline-block;
    margin-right: 5px;
  }
}
view {
  display: block;
}
.pointer {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.center-a {
  display: flex;
  align-items: center;
}
.center-j {
  display: flex;
  justify-content: center;
}
.stretch {
  display: flex;
  justify-content: center;
  align-items: stretch;
}
.between {
  display: flex;
  justify-content: space-between;
}

.primary {
  background-color: #007AFF;
}
.success {
  background-color: #00bb06;
}
.warning {
  background-color: #f8bf12;
}
.danger {
  background-color: #e52600;
}

span.link {
  color: #007AFF;
  cursor: pointer;
  margin: 0 5px;
  transition: transform .2s ease;
  &:hover {
    opacity: 0.8;
    transform: scale(1.02);
  }
  &:active {
    opacity: 1;
    color: #005AFF;
  }
}
.primary-t {
  color: #007AFF;
}
.success-t {
  color: #00bb06;
}
.warning-t {
  color: #f8bf12;
}
.danger-t {
  color: #e52600;
}
</style>
